import axios from 'axios'
import moment from 'moment'
import { URL } from '../../../env'

const TONES = {
  blue: ['blue lighten-5', 'blue darken-3'],
  violet: ['deep-purple lighten-5', 'deep-purple darken-3'],
  green: ['green lighten-5', 'green darken-3'],
  amber: ['amber lighten-5', 'amber darken-4'],
  rose: ['red lighten-5', 'red darken-3'],
  slate: ['blue-grey lighten-5', 'blue-grey darken-3'],
}

const PACE_TONES = {
  Ahead: { bg: 'green lighten-5', text: 'green darken-3' },
  'On Pace': { bg: 'blue lighten-5', text: 'blue darken-3' },
  'Slow Pay': { bg: 'amber lighten-5', text: 'amber darken-4' },
  Behind: { bg: 'red lighten-5', text: 'red darken-3' },
}
const NEUTRAL_TONE = { bg: 'grey lighten-3', text: 'blue-grey darken-2' }

export default {
  data() {
    const sid = localStorage.getItem('syndication_id')
    return {
      selectedAccount: sid === 'all' ? 'all' : parseInt(sid),
      user_id: localStorage.getItem('user_id'),
      stats: {},
      accountBreakdown: [],
      exportingBreakdown: false,
      payouts: [],
      page: 1,
      lastPage: 1,
      loadingPayouts: false,
      dialog: false,
      selectedItem: {},
      transactions: [],
      txPage: 1,
      txTotal: 0,
      loadingTable: false,
      rows: [],
      totalItems: 0,
      loadingPortfolio: false,
      exportingPortfolio: false,
      search: '',
      pagination: { sortBy: 'funded_date', descending: true, page: 1, rowsPerPage: 25 },
    }
  },
  mounted() {
    this.getSuperSyndicateStats()
    this.getAccountBreakdown()
    this.getPaydates()
    this.getPortfolio()
  },
  watch: {
    pagination: {
      handler() {
        this.getPortfolio()
      },
      deep: true,
    },
  },
  computed: {
    accountOptions() {
      return [{ id: 'all', syndicate_abbreviation: 'All Accounts' }].concat(this.syndicates || [])
    },
    statCards() {
      const s = this.stats
      return [
        { icon: 'attach_money', label: 'Capital Participated', value: s.capital_participated, currency: true, tone: 'blue' },
        { icon: 'gps_fixed', label: 'Expected RTR', value: s.expected_rtr, currency: true, tone: 'violet' },
        { icon: 'trending_up', label: 'Projected Profit', value: s.projected_profit, currency: true, tone: 'green' },
        { icon: 'receipt', label: 'Actual Profit', value: s.actual_profit, currency: true, tone: 'green' },
        { icon: 'account_balance_wallet', label: 'Collected to Date', value: s.collected_to_date, currency: true, tone: 'green' },
        { icon: 'pie_chart', label: 'Outstanding Balance', value: s.outstanding_balance, currency: true, tone: 'amber' },
        { icon: 'account_balance', label: 'Total Payouts', value: s.payout_due, currency: true, tone: 'blue' },
        { icon: 'account_balance_wallet', label: 'Cash Balance', value: s.cash_balance, currency: true, tone: 'blue' },
        { icon: 'layers', label: 'Active Deals', value: s.active_deals, currency: false, tone: 'slate' },
        { icon: 'rule', label: 'Collection Deals', value: s.collection_deals, currency: false, tone: 'amber' },
        { icon: 'warning', label: 'Defaults', value: s.default_deals, currency: false, tone: 'rose' },
        { icon: 'check_circle', label: 'Completed Deals', value: s.completed_deals, currency: false, tone: 'green' },
      ]
    },
  },
  methods: {
    onAccountChange() {
      if (this.selectedAccount === 'all') {
        localStorage.setItem('syndication_id', 'all')
        localStorage.setItem('name', 'All Accounts')
      } else {
        const filtered = (this.syndicates || []).filter(o => o.id == this.selectedAccount)
        localStorage.setItem('last_syndication_id', this.selectedAccount)
        localStorage.setItem('syndication_id', this.selectedAccount)
        if (filtered.length) {
          localStorage.setItem('selected_user_id', filtered[0].user_id)
          localStorage.setItem('name', filtered[0].syndicate_name)
        }
      }
      this.getSuperSyndicateStats()
      this.page = 1
      this.dialog = false
      this.getPaydates()
      this.pagination.page = 1
      this._lastKey = null
      this.getPortfolio()
    },
    tone(name) {
      return TONES[name]
    },
    getSuperSyndicateStats() {
      if (!this.selectedAccount) return
      axios
        .get(`${URL}/api/payouts/super_syndicate_stats/${this.selectedAccount}`, { params: { user_id: this.user_id } })
        .then(res => {
          this.stats = res.data
        })
    },
    getAccountBreakdown() {
      if (!this.user_id) return
      axios.get(`${URL}/api/payouts/super_syndicate_breakdown/${this.user_id}`).then(res => {
        this.accountBreakdown = (res.data && res.data.accounts) || []
      })
    },
    exportBreakdown() {
      if (!this.user_id) return
      this.exportingBreakdown = true
      axios({
        url: `${URL}/api/payouts/super_syndicate_breakdown/${this.user_id}`,
        method: 'GET',
        responseType: 'blob',
        params: { export: 1 },
      })
        .then(response => {
          this.download(response.data, 'account_breakdown.xlsx')
          this.exportingBreakdown = false
        })
        .catch(() => {
          this.exportingBreakdown = false
        })
    },
    accountCardFields(item) {
      return [
        { label: 'Capital Participated', value: item.invested },
        { label: 'Expected RTR (Return)', value: item.expectedReturn },
        { label: 'Projected Profit', value: item.projectedProfit, className: 'primary--text' },
        { label: 'Actual Profit', value: item.actualProfit, className: 'success--text' },
        { label: 'Total Payouts', value: item.payoutDue },
        { label: 'Outstanding Balance', value: item.outstandingBalance, className: 'info--text' },
      ]
    },
    percentCollected(item) {
      if (!item.expectedReturn) return 0
      return Math.round((item.payoutDue / item.expectedReturn) * 1000) / 10
    },
    getPaydates() {
      if (!this.selectedAccount) return
      this.loadingPayouts = true
      axios
        .get(`${URL}/api/payouts/get_payouts_paydates/${this.selectedAccount}`, { params: { page: this.page, length: 25, user_id: this.user_id } })
        .then(res => {
          const rows = (res.data && res.data.data) || []
          this.payouts = this.page === 1 ? rows : this.payouts.concat(rows)
          this.lastPage = (res.data && res.data.last_page) || 1
          this.loadingPayouts = false
        })
        .catch(() => {
          this.loadingPayouts = false
        })
    },
    loadMore() {
      if (this.page < this.lastPage) {
        this.page += 1
        this.getPaydates()
      }
    },
    openDialog(item) {
      this.selectedItem = item
      this.dialog = true
      this.txPage = 1
      this.transactions = []
      this.txTotal = 0
      this.getTransactions()
    },
    getTransactions() {
      if (!this.selectedItem || !this.selectedItem.pay_date) return
      this.loadingTable = true
      axios
        .get(`${URL}/api/payouts/get_payouts_wrt_paydate`, {
          params: { syndication_id: this.selectedItem.syndication_id, pay_date: this.selectedItem.pay_date, page: this.txPage, length: 25 },
        })
        .then(res => {
          const rows = (res.data && res.data.data) || []
          this.transactions = this.txPage === 1 ? rows : this.transactions.concat(rows)
          this.txTotal = (res.data && res.data.total) || 0
          this.loadingTable = false
        })
        .catch(() => {
          this.loadingTable = false
        })
    },
    loadMoreTransactions() {
      if (this.transactions.length < this.txTotal) {
        this.txPage += 1
        this.getTransactions()
      }
    },
    exportPayoutSheet(item) {
      axios({
        url: `${URL}/api/payouts/export_syndicated_payouts`,
        method: 'POST',
        responseType: 'blob',
        data: { syndication_id: item.syndication_id, pay_date: item.pay_date },
      }).then(response => this.download(response.data, 'payout_(' + item.pay_date + ').xlsx'))
    },
    getPortfolio() {
      if (!this.selectedAccount) return
      const params = {
        user_id: this.user_id,
        search: this.search || null,
        page: this.pagination.page,
        length: this.pagination.rowsPerPage,
        sortBy: this.pagination.sortBy,
        descending: this.pagination.descending,
      }
      const key = JSON.stringify(params)
      if (key === this._lastKey) return
      this._lastKey = key
      this.loadingPortfolio = true
      axios
        .get(`${URL}/api/payouts/super_syndicate_portfolio/${this.selectedAccount}`, { params })
        .then(res => {
          this.rows = (res.data && res.data.data) || []
          this.totalItems = (res.data && res.data.total) || 0
          this.loadingPortfolio = false
        })
        .catch(() => {
          this.loadingPortfolio = false
        })
    },
    onSearch() {
      if (this._searchTimer) clearTimeout(this._searchTimer)
      this._searchTimer = setTimeout(() => {
        this.pagination.page = 1
        this.getPortfolio()
      }, 600)
    },
    exportPortfolio() {
      if (!this.selectedAccount) return
      this.exportingPortfolio = true
      axios({
        url: `${URL}/api/payouts/super_syndicate_portfolio/${this.selectedAccount}`,
        method: 'GET',
        responseType: 'blob',
        params: {
          export: 1,
          user_id: this.user_id,
          search: this.search || null,
          sortBy: this.pagination.sortBy,
          descending: this.pagination.descending,
        },
      })
        .then(response => {
          this.download(response.data, 'consolidated_portfolio_report.xlsx')
          this.exportingPortfolio = false
        })
        .catch(() => {
          this.exportingPortfolio = false
        })
    },
    download(blob, file) {
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(new Blob([blob]))
      link.setAttribute('download', file)
      document.body.appendChild(link)
      link.click()
    },
    statusTone(status) {
      const s = (status || '').toLowerCase()
      if (s.indexOf('complete') > -1) return PACE_TONES.Ahead
      if (s.indexOf('legal') > -1) return PACE_TONES.Behind
      if (s.indexOf('collection') > -1) return PACE_TONES['Slow Pay']
      if (s.indexOf('active') > -1) return PACE_TONES['On Pace']
      return NEUTRAL_TONE
    },
    paceTone(pace) {
      return PACE_TONES[pace] || NEUTRAL_TONE
    },
    has(v) {
      return v !== null && v !== undefined && v !== ''
    },
    dash(v) {
      return this.has(v) ? v : '-'
    },
    formatDate(date) {
      if (!this.has(date)) return '-'
      const m = moment(date)
      return m.isValid() ? m.format('MMM DD, YYYY') : '-'
    },
  },
}
